export enum ModoVisualizacion {
  Esquema = 'ESQUEMA',
  Presentacion = 'PRESENTACION',
  Registro = 'REGISTRO',
  Documento = 'DOCUMENTO'
}
